import React, { useEffect } from 'react';
import RsvpActionBar from './RsvpActionBar';
import RsvpInfoBar from './RsvpInfoBar';
import { createAppContext, ReactAppCtx } from 'mini-app-context';
import { isEffectivelyActionable } from '../utils/isEffectivelyActionable';
import { RsvpUnitProps } from '../schema/RsvpUnit.types';
import { workFlowTrackerForRsvp } from '../utils/workFlowTrackerForRsvp';

const RsvpUnit: React.FC<RsvpUnitProps> = props => {
    useEffect(() => {
        workFlowTrackerForRsvp();
    }, []);

    if (!props.item) {
        return null;
    }

    if (isEffectivelyActionable(props)) {
        const context = createAppContext();
        return (
            <ReactAppCtx.Provider value={context}>
                <RsvpActionBar {...props} />
            </ReactAppCtx.Provider>
        );
    }

    return <RsvpInfoBar {...props} />;
};

RsvpUnit.defaultProps = { isActionable: true };

export default RsvpUnit;
